import React, { Component } from 'react'
import {
    Link,
    Redirect
} from 'react-router-dom'
import { AppContext, AccountFeatures } from '@lightspeed-invoicing/core-client/frontend'
import { FormattedMessage, injectIntl, defineMessages } from 'react-intl'
import RichTextEditor from '../../common/rich-text/editor.component.jsx'
import $ from 'jquery'
import SideBar from '../../common/layout/sidebar.component.jsx'
import GlobalHelper from "../../common/GlobalHelper.jsx"
import ConfirmButton from "../../common/button/confirmbutton.component.jsx"
import EmailInput from '../../common/inputs/EmailInputComponent.tsx'
import { TYPE_MAIL } from '../../state/template/TemplateType'
import {withRouter} from "react-router"

const messages = defineMessages({
    "default_name": {
        id: 'templates.default_template_name',
        defaultMessage: 'Default template',
    },
})
class EmailTemplatesEditForm extends Component {

    constructor(props, context) {
        super(props, context);

        this.state = {
            template: {},
            subject: '',
            content: '',
            templateType: TYPE_MAIL,
            templateKey: '',
            buttonLabel: '',
            fromName: '',
            defaultFromEmail: '',
            defaultBccEmail: '',
            attachPdfByDefault: false,
            name: this.props.intl.formatMessage(messages['default_name']),
            status: '',
            isNew: this.props.isNew || false,
            deleteButton: '',
            isLoading: false,
        }

        this.templateId = this.props.match ? this.props.match.params.templateId : ''
        this.templateKey = this.props.match ? this.props.match.params.templateKey : this.props.templateKey
        this.handleFormChange = this.handleFormChange.bind(this)
        this.submitTemplate = this.submitTemplate.bind(this)
        this.handleRichTextChange = this.handleRichTextChange.bind(this)
        this.deleteTemplate = this.deleteTemplate.bind(this);
    }

    componentDidMount() {
        this.setState({ isLoading: true })
        SideBar.activateMenu('sales-tools')
        AppContext.getApiClient().get(`/templates/${this.templateId || this.templateKey}/template`).then(res => {

            const deleteButton = <ConfirmButton identifier={res.attributes.name || this.state.name} onClick={this.deleteTemplate} className="btn btn-danger">
                <FormattedMessage
                    id="settings.emails.templates.form.edit.delete_btn"
                    defaultMessage="Delete"
                />
            </ConfirmButton>
            let attachPdf = false
            if (res.attributes.templateKey === "send-account-statement") {
                attachPdf = res.attributes.attachPdfByDefault && AppContext.accountFeatureIsEnabled(AccountFeatures.FeatureAccountStatements)
            }
            if (res.attributes.templateKey === "send-invoice") {
                attachPdf = res.attributes.attachPdfByDefault && AppContext.accountFeatureIsEnabled(AccountFeatures.FeatureIncludePdfAttachmentInInvoice)
            }
            this.setState({
                template: res,
                subject: res.attributes.subject,
                templateKey: res.attributes.templateKey,
                content: res.attributes.content,
                buttonLabel: res.attributes.buttonLabel,
                defaultFromEmail: res.attributes.defaultFromEmail,
                defaultBccEmail: res.attributes.defaultBccEmail,
                name: res.attributes.name || this.state.name,
                status: res.attributes.status,
                deleteButton: deleteButton,
                attachPdfByDefault: attachPdf,
                fromName: res.attributes.fromName,
                isLoading: false,
            })
            $('#subject').focus()
        })
    }

    submitTemplate(event) {
        event.preventDefault()
        let updates = {}
        const allowedFormFields = ["subject", "content", "templateType", "buttonLabel", "defaultFromEmail", "defaultBccEmail", "attachPdfByDefault", "name", "fromName"]

        for (let i = 0; i < allowedFormFields.length; i++) {
            let field = allowedFormFields[i]
            if (this.state.isNew || this.state[field] != this.state.template.attributes[field]) {
                updates[field] = this.state[field]
            }
        }
        if (!this.state.isNew) {
            AppContext.getApiClient().patch(`/templates/${this.templateId || this.templateKey}`, updates).then(response => {
                if (!response.error) {
                    if (this.state.templateKey === "send-stock-document") {
                        this.props.history.push(`/inventory/document-types?emailTemplateId=${this.state.template.id}`)
                        return
                    }
                    this.setState({ formStatus: <Redirect to={{ pathname: !this.templateId ? '/branding' : `/settings/email-templates/${this.state.templateKey}/listing` }} /> })
                }
            })
        } else {

            AppContext.getApiClient().post(`/templates/${this.templateKey}`, updates).then(response => {
                if (!response.error) {
                    if (this.templateKey === "send-stock-document") {
                        this.props.history.push(`/inventory/document-types?emailTemplateId=${this.state.template.id}`)
                        return
                    }
                    this.setState({ formStatus: <Redirect to={{ pathname: `/settings/email-templates/${this.state.templateKey}/listing` }} /> })
                }
            })
        }
    }

    deleteTemplate(event) {
        event.preventDefault()
        AppContext.getApiClient().delete(`/templates/${this.templateId}`).then(response => {
            if (!response.error) {
                setTimeout(() => {
                    this.setState({ formStatus: <Redirect to={{ pathname: `/settings/email-templates/${this.state.templateKey}/listing` }} /> })
                }, 500)
            }
        })
    }

    handleFormChange(event) {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;

        this.setState({
            [name]: value
        });
    }

    handleRichTextChange(value) {
        this.setState({
            content: value
        });
    }

    render() {
        const cancelUrl = this.state.templateKey === "send-stock-document" ? `/inventory/document-types?emailTemplateId=${this.state.template.id}` :
            !this.templateId ? "/branding" : `/settings/email-templates/${this.state.templateKey}/listing`

        const messages = defineMessages({
            "save_btn": {
                id: 'settings.emails.templates.form.edit.save_btn',
                defaultMessage: 'Save',
            },
            "create_btn": {
                id: 'settings.emails.templates.form.edit.create_btn',
                defaultMessage: 'Create',
            },
            "subject_placeholder": {
                id: 'settings.emails.template.form.edit.subject_placeholder',
                defaultMessage: 'Subject of the email',
            },
            "button_label_placeholder": {
                id: 'settings.emails.template.form.edit.button_label_placeholder',
                defaultMessage: 'Label on the "Open" button',
            },
            "default_from_email_placeholder": {
                id: 'settings.emails.template.form.edit.default_from_email_placeholder',
                defaultMessage: 'From email address',
            },
            "default_bcc_email_placeholder": {
                id: 'settings.emails.template.form.edit.default_bcc_email_placeholder',
                defaultMessage: 'BCC email address',
            },
            "name_placeholder": {
                id: 'settings.emails.template.form.edit.name_placeholder',
                defaultMessage: 'Name of the template',
            },
            "default_from_name_placeholder": {
                id: 'settings.emails.template.form.edit.default_from_name_placeholder',
                defaultMessage: 'From name',
            },
        })
        return (
            <div>
                <form onSubmit={this.submitTemplate}>
                    <div className="row ui-has-modules">
                        <div className="col-12 ui-module">
                            <div className="form-group row">
                                <label className="col-2 col-form-label text-align-right" htmlFor="name">
                                    <FormattedMessage
                                        id="settings.emails.template.form.edit.name_label"
                                        defaultMessage="Name"
                                    />
                                </label>
                                <div className="col-10">
                                    <input
                                        name="name"
                                        value={this.state.name}
                                        onChange={this.handleFormChange}
                                        id="name"
                                        type="text"
                                        className="form-control"
                                        placeholder={this.props.intl.formatMessage(messages['name_placeholder'])}
                                    />
                                    <small className="form-text text-muted">
                                        <FormattedMessage
                                            id="settings.emails.template.form.edit.name_description"
                                            defaultMessage="Name of the template"
                                        />
                                    </small>
                                </div>
                            </div>
                            <div className="form-group row">
                                <label className="col-2 col-form-label text-align-right" htmlFor="subject">
                                    <FormattedMessage
                                        id="settings.emails.template.form.edit.subject_label"
                                        defaultMessage="Subject"
                                    />
                                </label>
                                <div className="col-10">
                                    <input
                                        name="subject"
                                        value={this.state.subject}
                                        onChange={this.handleFormChange}
                                        id="subject"
                                        type="text"
                                        className="form-control"
                                        placeholder={this.props.intl.formatMessage(messages['subject_placeholder'])}
                                    />
                                    <small className="form-text text-muted">
                                        <FormattedMessage
                                            id="settings.emails.template.form.edit.subject_description"
                                            defaultMessage="Subject of the email"
                                        />
                                    </small>
                                </div>
                            </div>
                            <div className="form-group row">
                                <label className="col-2 col-form-label text-align-right" htmlFor="defaultFromEmail">
                                    <FormattedMessage
                                        id="settings.emails.template.form.edit.default_from_email_label"
                                        defaultMessage="From"
                                    />
                                </label>
                                <div className="col-10">
                                    <EmailInput
                                        name="defaultFromEmail"
                                        email={this.state.defaultFromEmail}
                                        handleFormChange={this.handleFormChange}
                                        id="defaultFromEmail"
                                        type="text"
                                        className="form-control"
                                        placeholder={this.props.intl.formatMessage(messages['default_from_email_placeholder'])}
                                    />
                                    <small className="form-text text-muted">
                                        <FormattedMessage
                                            id="settings.emails.template.form.edit.default_from_email_description"
                                            defaultMessage="The default from mail address of the email template. The emails sent using this template will use this address unless one of the other options provided is selected."
                                        />
                                    </small>
                                </div>
                            </div>
                            <div className="form-group row">
                                <label className="col-2 col-form-label text-align-right" htmlFor="fromName">
                                    <FormattedMessage
                                        id="settings.emails.template.form.edit.default_sender_name_label"
                                        defaultMessage="From name"
                                    />
                                </label>
                                <div className="col-10">
                                    <input
                                        name="fromName"
                                        value={this.state.fromName}
                                        onChange={this.handleFormChange}
                                        id="fromName"
                                        type="text"
                                        className="form-control"
                                        placeholder={this.props.intl.formatMessage(messages['default_from_name_placeholder'])}
                                    />
                                    <small className="form-text text-muted">
                                        <FormattedMessage
                                            id="settings.emails.template.form.edit.default_from_name_email_description"
                                            defaultMessage="The default sender name of the email template. The emails sent using this template will use this name, otherwise it will use the name of the user who is assigned to the document."
                                        />
                                    </small>
                                </div>
                            </div>
                            <div className="form-group row">
                                <label className="col-2 col-form-label text-align-right" htmlFor="defaultBccEmail">
                                    <FormattedMessage
                                        id="settings.emails.template.form.edit.default_bcc_email_label"
                                        defaultMessage="BCC"
                                    />
                                </label>
                                <div className="col-10">
                                    <EmailInput
                                        name="defaultBccEmail"
                                        email={this.state.defaultBccEmail}
                                        handleFormChange={this.handleFormChange}
                                        id="defaultBccEmail"
                                        type="text"
                                        className="form-control"
                                        placeholder={this.props.intl.formatMessage(messages['default_bcc_email_placeholder'])}

                                    />
                                    <small className="form-text text-muted">
                                        <FormattedMessage
                                            id="settings.emails.template.form.edit.default_bcc_email_description"
                                            defaultMessage="The default BCC email address of the email template. The emails sent using this template will use this address unless a change made while drafting an email."
                                        />
                                    </small>
                                </div>
                            </div>
                            <div className="form-group row">
                                <label className="col-2 col-form-label text-align-right" htmlFor="content">
                                    <FormattedMessage
                                        id="settings.emails.template.form.edit.content_label"
                                        defaultMessage="Content"
                                    />
                                </label>
                                <div className="col-10">
                                    <RichTextEditor
                                        height={400}
                                        name="content"
                                        value={this.state.content}
                                        onChange={this.handleRichTextChange}
                                        id="content"
                                        className="form-control"
                                    />
                                    <small className="form-text text-muted">
                                        <FormattedMessage
                                            id="settings.emails.template.form.edit.content_description"
                                            defaultMessage="Content of the email"
                                        />
                                    </small>
                                </div>
                            </div>
                            {(AppContext.accountFeatureIsEnabled(AccountFeatures.FeatureIncludePdfAttachmentInInvoice) && this.state.templateKey === "send-invoice") ||
                                (AppContext.accountFeatureIsEnabled(AccountFeatures.FeatureAccountStatements) && this.state.templateKey === "send-account-statement") ?
                                <div className="form-group row">
                                    <div className="col-2"></div>
                                    <div className="col-8">
                                        <div className="custom-control custom-checkbox">
                                            <input
                                                type="checkbox"
                                                className="custom-control-input"
                                                id="attachPdfByDefault"
                                                name="attachPdfByDefault"
                                                onChange={this.handleFormChange}
                                                checked={this.state.attachPdfByDefault}
                                            />
                                            <label className="custom-control-label" htmlFor="attachPdfByDefault">
                                                <FormattedMessage
                                                    id="common.send_email.modal.include_pdf_attachment"
                                                    defaultMessage="Include Pdf attachment"
                                                />
                                            </label>
                                        </div>
                                    </div>
                                </div> : ''
                            }
                            <div className="form-group row">
                                <label className="col-2 col-form-label text-align-right" htmlFor="subject">
                                    <FormattedMessage
                                        id="settings.emails.template.form.edit.button_label"
                                        defaultMessage="Button text"
                                    />
                                </label>
                                <div className="col-10">
                                    <input
                                        name="buttonLabel"
                                        value={this.state.buttonLabel}
                                        onChange={this.handleFormChange}
                                        id="buttonLabel"
                                        type="text"
                                        className="form-control"
                                        placeholder={this.props.intl.formatMessage(messages['button_label_placeholder'])}
                                    />
                                    <small className="form-text text-muted">
                                        <FormattedMessage
                                            id="settings.emails.template.form.edit.button_label_description"
                                            defaultMessage="Label on the 'Open' button"
                                        />
                                    </small>
                                </div>
                            </div>
                        </div>
                        <div className="col-12">
                            {this.state.formStatus}
                        </div>
                        <div className="col-12 ui-module">
                            <div className="row">
                                <div className="col-6 text-align-left">
                                    {!this.state.isNew && this.templateId && this.state.status !== 'default' &&
                                        this.state.deleteButton
                                    }
                                </div>
                                <div className="col-6 text-align-right">
                                    <Link to={this.state.isLoading ? "#" : cancelUrl} className="btn btn-light">
                                        <FormattedMessage
                                            id="settings.emails.template.form.cancel_btn"
                                            defaultMessage="Cancel"
                                        />
                                    </Link>
                                    &nbsp;
                                    &nbsp;
                                    <input type="submit" disabled={this.state.isLoading}
                                        value={this.props.intl.formatMessage(messages[!this.state.isNew ? 'save_btn' : 'create_btn'])}
                                        className="btn btn-primary" />
                                </div>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        )
    }
}

export default withRouter(injectIntl(EmailTemplatesEditForm))


// WEBPACK FOOTER //
// ./src/settings/emails/editForm.component.jsx